<template>
  <div class="rounded-lg bg-white py-4 px-6 shadow-md">
    <h2 class="pb-2" v-if="title">{{ title }}</h2>
    <slot />
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Card",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
});
</script>
